'use strict';

module.exports = /* @ngInject */ function($resource, apiConfig) {

    
    return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		getAddressesByCustomerGroupId: $resource(
					apiConfig.$get().apiUrl + '/customer/address?customerCompanyId=:customerCompanyId',
					{
						customerCompanyId: '@customerCompanyId'
					}
				)
	};

}
